/* eslint eqeqeq: "off" */
import { Snackbar } from "@material-ui/core";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ContentRoute, useSubheader } from "../../../../_metronic/layout";
import { EmailDialog } from "../../../../_zebra/_components/EmailDialog";
import { SnackbarWrapper } from "../../Snackbar/SnackbarWrapper";
import { ProgramActivateDialog } from "./Components/ProgramActivateDialog";
import { useProgramContext } from "./Components/ProgramDataContext";
import { ProgramDeleteDialog } from "./Components/ProgramDeleteDialog";
import { ProgramFilters } from "./Components/ProgramFilters";
import { ProgramFullDialog } from "./Components/ProgramFullDialog";
import { ProgramPointsDialog } from "./Components/ProgramPointsDialog";
import { SchoolProgramAttendanceDialog } from "./Components/SchoolProgramAttendanceDialog";
import SchoolProgramTable from "./Components/ProgramTable";

export const ProgramList = () => {
  const [data, setData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [emailSuccessOpen, setEmailSuccessOpen] = useState(false);
  const [emailErrorOpen, setEmailErrorOpen] = useState(false);
  const [attendanceSavedOpen, setAttendanceSavedOpen] = useState(false);
  // { seq, variant: "success" | "error", message }. `open` drives visibility
  // so the last toast keeps its colour and text through the exit transition;
  // `seq` keys the Snackbar so each new toast gets its own 3s.
  const [fullToast, setFullToast] = useState({ seq: 0, variant: "success", message: "" });
  const [fullToastOpen, setFullToastOpen] = useState(false);
  const { branch, authUser } = useSelector(
    (state) => ({
      branch: state.auth.branches.currentBranch,
      authUser: state.auth.user,
    }),
    shallowEqual
  );
  const context = useProgramContext();
  const access = useSelector((state) => state.auth.access, shallowEqual);
  const suhbeader = useSubheader();
  suhbeader.setTitle("School Program List");
  const schoolProgramsUrl = "api/school-programs/branch/";

  async function fetchSchoolProgramsForBranch() {
    let activeValues = ["Active", "In-Active"];
    setLoading(true);
    const result = await axios(schoolProgramsUrl + branch.branch_id);
    result.data.result.sort((a, b) => {
      return (
        activeValues.indexOf(a.active_value) -
        activeValues.indexOf(b.active_value)
      );
    });
    setData(result.data.result);
    setOrigData(result.data.result);
    setLoading(false);
  }

  const handleClose = () => {
    setEmailSuccessOpen(false);
    setEmailErrorOpen(false);
  };

  //fetching school programs for a branch
  useEffect(() => {
    branch && fetchSchoolProgramsForBranch();
    // eslint-disable-next-line
  }, [branch]);

  //fetching school programs for a branch
  useEffect(() => {
    context.refetch && fetchSchoolProgramsForBranch();
    context.setRefetch(false);
    // eslint-disable-next-line
  }, [context.refetch]);

  //Filter Data based on search
  const filterData = (filters) => {
    const newData = origData.filter(function(item) {
      var add = true;
      for (let key in filters) {
        if (filters[key] !== "") {
          if (key === "courses") {
            let common = item[key].filter((b) => {
              return filters[key].includes(b.course_code);
            });
            if (common.length == 0) {
              add = false;
            }
          } else if (key === "date") {
            if (
              !moment(filters[key]).isBefore(
                moment(item["enddate"], "yyyy-MM-DD").add(1, "days")
              )
            ) {
              add = false;
            }
          } else if (key === "id") {
            if (!(item["school_program_id"] + "").includes(filters[key])) {
              add = false;
            }
          } else if (key === "school_type_id") {
            if (!(item["school_type_id"] + "").includes(filters[key])) {
              add = false;
            }
          } else if (key === "school_name") {
            // Handle school filter - compare the school_name
            if (item["school_name"] !== filters[key]) {
              add = false;
            }
          } else {
            // Handle all other filters
            if (item[key] === undefined || item[key] !== filters[key]) {
              add = false;
            }
          }
        }
      }
      return add && true;
    });
    setData(newData);
  };
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={emailSuccessOpen ? emailErrorOpen : false}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={emailSuccessOpen ? "success" : "error"}
          message={
            emailSuccessOpen
              ? "Email Successfully sent"
              : "Something went wrong"
          }
        />
      </Snackbar>
      {/* The list refetch after a save re-submits the filter form with a
          programmatic click (ProgramFilters), which MUI's Snackbar reports as
          a click-away; ignoring that reason keeps the toast up for its 3s. */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={attendanceSavedOpen}
        autoHideDuration={3000}
        onClose={(e, reason) => reason !== "clickaway" && setAttendanceSavedOpen(false)}
      >
        <SnackbarWrapper
          onClose={() => setAttendanceSavedOpen(false)}
          variant="success"
          message="Attendance Marked"
        />
      </Snackbar>
      <Snackbar
        key={fullToast.seq}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={fullToastOpen}
        autoHideDuration={3000}
        onClose={(e, reason) => reason !== "clickaway" && setFullToastOpen(false)}
      >
        <SnackbarWrapper
          onClose={() => setFullToastOpen(false)}
          variant={fullToast.variant}
          message={fullToast.message}
        />
      </Snackbar>
      <div className={`card card-custom`}>
        {/* begin::Header */}
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              School Program Filters
            </span>
          </h3>
          {access["batches"] == 0 && (
            <div className="card-toolbar">
              <Link
                to="/school-programs/add-program"
                className="btn btn-primary font-weight-bolder font-size-sm"
              >
                Add New School Program
              </Link>
            </div>
          )}
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body py-0">
          <ProgramFilters
            filterData={filterData}
            origData={origData}
            loading={loading}
          />
        </div>
      </div>

      <SchoolProgramTable programs={data} showActions={true} loading={loading} />

      <ContentRoute path="/school-programs/program-list/:id/points">
        {({ history, match }) => (
          <ProgramPointsDialog
            id={match && match.params.id}
            show={match != null}
            onHide={() => {
              history.push("/school-programs/program-list");
            }}
          />
        )}
      </ContentRoute>

      <ContentRoute path="/school-programs/program-list/:id/delete-program">
        {({ history, match }) => (
          <ProgramDeleteDialog
            history={history}
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/school-programs/program-list");
            }}
          />
        )}
      </ContentRoute>

      <ContentRoute path="/school-programs/program-list/:id/activate-program">
        {({ history, match }) => (
          <ProgramActivateDialog
            history={history}
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/school-programs/program-list");
            }}
          />
        )}
      </ContentRoute>

      <ContentRoute path="/school-programs/program-list/:id/full/:value">
        {({ history, match }) => (
          <ProgramFullDialog
            history={history}
            // Only "0" / "1" are valid; anything else (a hand-typed URL) opens
            // nothing, since a null id makes the dialog close itself.
            id={match && ["0", "1"].includes(match.params.value) ? match.params.id : null}
            full={match ? match.params.value === "1" : false}
            show={match != null}
            onHide={() => {
              history.push("/school-programs/program-list");
            }}
            onResult={(ok, full, serverMessage) => {
              setFullToast((prev) => ({
                seq: prev.seq + 1,
                variant: ok ? "success" : "error",
                message: ok
                  ? full
                    ? "Marked program full successfully"
                    : "Marked program not full successfully"
                  : serverMessage || "Something went wrong",
              }));
              setFullToastOpen(true);
            }}
          />
        )}
      </ContentRoute>

      <ContentRoute path="/school-programs/program-list/:id/attendance/:days">
        {({ history, match }) => (
          <SchoolProgramAttendanceDialog
            key={match ? match.params.id : "closed"}
            programId={match && match.params.id}
            days={match && match.params.days !== "-" ? decodeURIComponent(match.params.days) : ""}
            show={match != null}
            onHide={() => {
              history.push("/school-programs/program-list");
            }}
            onSaved={() => setAttendanceSavedOpen(true)}
          />
        )}
      </ContentRoute>

      <ContentRoute path="/school-programs/program-list/:id/email">
        {({ history, match }) => (
          <EmailDialog
            history={history}
            routePath={"/school-programs/program-list"}
            camp_ind={true}
            emailsPath={`api/school-programs/${match && match.params.id}/all-emails`}
            id={match && match.params.id}
            branch_id={branch && branch.branch_id}
            userId={authUser && authUser[0].user_id}
            show={match != null}
            onHide={() => {
              history.push("/school-programs/program-list");
            }}
            setEmailSuccessOpen={setEmailSuccessOpen}
            setEmailErrorOpen={setEmailErrorOpen}
          />
        )}
      </ContentRoute>
    </div>
  );
};
